import { Snackbar } from '@mui/material'
import React, { useState } from 'react'

const SnackBar = (props) => {
  return <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} {...props} />
}

export default SnackBar
